export const FULFILLMENT_METHOD_STORAGE_KEY = "client_fulfillmentMethod";
export class FulfillmentMethodTypeStorageManager {
    constructor(availableFulfillmentMethods) {
        this.availableFulfillmentMethods = availableFulfillmentMethods;
    }
    store(fulfillmentMethodType) {
        const fulfillmentMethodStorageKeyString = JSON.stringify(fulfillmentMethodType);
        localStorage.setItem(FULFILLMENT_METHOD_STORAGE_KEY, fulfillmentMethodStorageKeyString);
    }
    restore() {
        const fulfillmentMethodString = localStorage.getItem(FULFILLMENT_METHOD_STORAGE_KEY);
        if (fulfillmentMethodString !== null) {
            const fulfillmentMethodType = JSON.parse(fulfillmentMethodString);
            if (this.availableFulfillmentMethods.includes(fulfillmentMethodType)) {
                return fulfillmentMethodType;
            }
        }
        return null;
    }
    erase() {
        localStorage.removeItem(FULFILLMENT_METHOD_STORAGE_KEY);
    }
}
